import { render, staticRenderFns } from "./MetricBar.vue?vue&type=template&id=422e1d6c&scoped=true"
import script from "./MetricBar.vue?vue&type=script&lang=js"
export * from "./MetricBar.vue?vue&type=script&lang=js"
import style0 from "./MetricBar.vue?vue&type=style&index=0&id=422e1d6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422e1d6c",
  null
  
)

export default component.exports